import { render } from "./SabhaSecretaries.vue?vue&type=template&id=dc917fec&scoped=true"
import script from "./SabhaSecretaries.vue?vue&type=script&lang=js"
export * from "./SabhaSecretaries.vue?vue&type=script&lang=js"

import "./SabhaSecretaries.vue?vue&type=style&index=0&id=dc917fec&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc917fec"]])

export default __exports__